export function containsLoremFlickr(url) {
  const substring = "https://";
  if (url) {
    return url.includes(substring);
  }
}
